module.exports = __webpack_public_path__ + "img/camera_board.4c8fcdbe.jpg";